import React from "react";

export default (props) => {
  return <div className="px-4 py-8 lg:ml-1">{props.postContent}</div>;
};
